import React from "react"
import Hero from "./hero.module.scss"
import Text from "../styles/typography.module.scss"
import button from "./button.module.scss"
import HeroWaves from "../images/waves/waves.svg"
import Img from "gatsby-image"
import { StaticQuery, Link } from "gatsby"

export default function hero() {
  return (
    <StaticQuery
      query={graphql`
        query {
          file(relativePath: { eq: "images/hero-illustration.png" }) {
            name
            childImageSharp {
              fluid(fit: CONTAIN) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => (
        <div className={Hero.section}>
          <div className={Hero.wrapper}>
            <div className={Hero.layout}>
              <h1 className={Text.display}>
                Streamline meeting minutes with MinutScript
              </h1>
              <p className={Text.subdisplay}>
                MinutScript is a meeting management software, developed to
                minimize time spent and maximize effectivity. With automatic
                transcription build-in, just press record and you are ready to
                share and edit your meeting minutes.
              </p>
              <div>
                <Link
                  to="/404/"
                  className={`${button.btn} ${button.cta}`}
                >
                  Get app
                </Link>
                <Link to="/news/" className={`${button.btn} ${button.primary}`}>
                  Read more
                </Link>
              </div>
            </div>
            <div className={Hero.imgcontainer}>
              <Img fluid={data.file.childImageSharp.fluid} />
            </div>
          </div>
          <img className={Hero.waves} src={HeroWaves} alt="" />
        </div>
      )}
    />
  )
}
